/*
 *  Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { DateRange, EstatePeriod, Granularity } from "~/components";
import {
  getEndDate,
  getStartDate,
  EstateRecordsCostPerOrgUnit,
} from "~/views/estate/components/Charts";

type Props = {
  period: EstatePeriod;
  granularity: Granularity;
  range: DateRange;
};

export function EstateRecordsOrgUnitView({
  period,
  granularity,
  range,
}: Props) {
  const startDate =
    range.from ?? getStartDate(EstatePeriod.DEFAULT_MONTH, undefined);
  const endDate = range.to ?? getEndDate(EstatePeriod.DEFAULT_MONTH, undefined);

  return (
    <EstateRecordsCostPerOrgUnit
      granularity={granularity}
      startDate={startDate}
      endDate={endDate}
      period={period}
    />
  );
}
